import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import ChevronRightLargeIcon from '@atlaskit/icon/glyph/chevron-right-large';
import Navigator from './Navigator';
export default class RightNavigator extends Component {
  render() {
    return /*#__PURE__*/React.createElement(Navigator, this.props);
  }

}

_defineProperty(RightNavigator, "defaultProps", {
  'aria-label': 'next',
  iconBefore: /*#__PURE__*/React.createElement(ChevronRightLargeIcon, {
    label: ""
  }),
  isDisabled: false
});